import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import testImage from '../../assets/images/team_placeholder.png';
import ClubbieTable from '../../components/ClubbieTable/ClubbieTable';
import { fixedValues } from '../../utils/fixedValues';

/**
 * OrganisationMembersV2 - Modern JSX component with Tailwind CSS
 * Displays organization members (referees) with their roles
 * Uses ClubbieTable for data presentation
 */
const OrganisationMembersV2 = () => {
  const { selectedTournament } = useSelector((state) => state.tournament);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'fullName',
        header: () => <span className="text-[#FEFCEB]">Name</span>,
        cell: ({ row }) => (
          <div className="flex items-center gap-3">
            <img
              src={row.original?.image || testImage}
              alt="profile"
              className="w-8 h-8 rounded-full object-cover"
              onError={(e) => {
                e.target.src = testImage;
              }}
            />
            <span className="text-[#FEFCEB]">{row.original?.fullName || 'N/A'}</span>
          </div>
        ),
      },
      {
        accessorKey: 'role',
        header: () => <span className="text-[#FEFCEB]">Role</span>,
        cell: ({ getValue }) => {
          const role = getValue();
          let roleLabel = role;
          
          if (role === fixedValues.userRoles.ORGANISATION_ADMIN) {
            roleLabel = 'Organisation Admin';
          } else if (role === fixedValues.userRoles.TOURNAMENT_ADMIN) {
            roleLabel = 'Competition Admin';
          } else if (role === fixedValues.userRoles.DIVISION_ADMIN) {
            roleLabel = 'Division Admin';
          } else if (role === fixedValues.userRoles.REFEREE) {
            roleLabel = 'Referee';
          }

          return <span className="text-[#FEFCEB]">{roleLabel}</span>;
        },
      },
    ],
    []
  );

  const data = useMemo(() => {
    if (!selectedTournament?.members) return [];
    return selectedTournament.members
      .filter((m) => m.role === "referee" || m.role === "tournamentAdmin")
      .filter((m) => m.userId?.profile)
      .map((m) => ({
        fullName: m.userId.profile.fullName,
        role: m.role,
        id: m._id,
        userId: m.userId._id,
        image: m.userId.profile?.image,
      }));
  }, [selectedTournament]);

  return (
    <div className="min-h-screen bg-[#000F1F] text-[#FEFCEB]">
      <div className="max-w-[1400px] mx-auto py-6 px-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-[#FEFCEB] m-0">Organisation Members</h1>
        </div>
        <ClubbieTable data={data} columns={columns} title="Organisation Members" pageSize={10} />
      </div>
    </div>
  );
};

export default OrganisationMembersV2;
